define('SageDotCom/DataLayer/Events/loginStart',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function ButtonClickEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "login_start"; // overwrite name
    }

    ButtonClickEvent.prototype = Object.create(EventBase.prototype);

    ButtonClickEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, label) {
        var btnClass = $(scope).attr("class") || "";
        var btnText = $(scope).text() || "";
        var btnId = $(scope).attr("id") || "";
        var destinationUrl = $(scope).attr("href") || $("a:first", scope).attr("href") || "";

        var eventData = {
            'event_name': this.getName(),
            'destination_url': destinationUrl,
            'element_text': btnText,
            'element_class': btnClass,
            'element_id': btnId,
            'release_date': "18th July 2024"
        }
        
        return eventData;
    }

    return new ButtonClickEvent();
});
